import AxiosInstance from './config/Http';
import Config from './config/Constants';
import { fetchAllPages } from './config/Pagination';

// Obtiene todas las facturas
export const getInvoices = async ({ page = 0, size = 20, sort = 'issueDate,desc' } = {}) => {
  try {
    const response = await fetchAllPages<any>(`${Config.core.invoices}`, { page, sort }, size);

    return { status: true, json: response.data };
  } catch (error: any) {
    console.error('Error in getInvoices', error);
    return {
      status: false,
      message:
        'Hubo un error al obtener facturas, intente luego. ' +
        (error.response?.status || ''),
    };
  }
};
